import {
  SALESGOALS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  SALESGOALS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  SALESGOALS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  SALESGOALS_MASSIVE_UPLOAD_SET_VERIFY,
  SALESGOALS_MASSIVE_UPLOAD_CLEAR_VERIFY,
  SALESGOALS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  SALESGOALS_MASSIVE_UPLOAD_SET_UPLOAD,
  SALESGOALS_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function salesGoalsMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case SALESGOALS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case SALESGOALS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case SALESGOALS_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case SALESGOALS_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case SALESGOALS_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case SALESGOALS_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case SALESGOALS_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case SALESGOALS_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default salesGoalsMassiveUploadReducer;
